import React from 'react'
import Navbar from '../header/Navbar'
import HeroImg from '../additional/HeroImg'
import Footer from '../footer/Footer'
import ContactForm from '../additional/ContactForm'
import AboutContent from '../additional/AboutContent'
import FAQ from '../additional/FAQ'
import Projects from '../additional/Projects'
import PricingCard from '../additional/PricingCard'

const Home = () => {
  return (
    <div>
        <Navbar/>
        <HeroImg/>
        <Projects/>
        {/* <PricingCard/>
        <AboutContent/>
        <ContactForm/>
        <FAQ/> */}
        <Footer/>
    </div>
  )
}

export default Home